'use strict';

function apply_sticky_category_nav() {
	$(".page-header").addClass("js-fixed-header");
	$(".logo-top").removeClass("logo-show");
	$(".logo-fixed").addClass("logo-show");
}

function remove_sticky_category_nav() {
	$(".page-header").removeClass("js-fixed-header");
	$(".logo-top").addClass("logo-show");
	$(".logo-fixed").removeClass("logo-show");
}

// When scrolling down past a certain point make the filter nav fixed.
function sticky_header() {
	var scroll_limit = -1;
	// Pixel height scrolled until Fixed Header shows
    scroll_limit 	 = 200;

    if($(window).scrollTop() >= scroll_limit && scroll_limit !== -1) {
        apply_sticky_category_nav();
    } else {
        remove_sticky_category_nav();
    }
}

(function( $ ) {
    if($('.page-header').length >= 1) {
    	$(window).load(sticky_header);

        // When you scroll automatically highlight categories.
        $(window).on('scroll', sticky_header);
    }
})(jQuery);
